import type { StoreApi, UseBoundStore } from 'zustand';
import { persist } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface ActiveWalletState {
  activeWalletId: string | null;
  hasHydrated: boolean;
  setActiveWalletId: (id: string | null) => void;
  markHydrated: () => void;
}

export const useActiveWalletStore: UseBoundStore<StoreApi<ActiveWalletState>> =
  createTrackedStore<ActiveWalletState>('useActiveWalletStore')(
    persist(
      (set) => ({
        activeWalletId: null,
        hasHydrated: false,
        setActiveWalletId: (id: string | null): void => {
          set({ activeWalletId: id });
        },
        markHydrated: (): void => {
          set({ hasHydrated: true });
        },
      }),
      {
        name: 'morfi-active-wallet',
        onRehydrateStorage: (state: ActiveWalletState) => (): void => {
          state.markHydrated();
        },
      },
    ),
  );
